import PropTypes from "prop-types"
import React, { useEffect } from "react"
import styled from "styled-components"

import StyledBottomSheet from "../../../../../_shared/components/BottomSheet"
import AppInput from "../../../../../_shared/components/FormItems/AppInput"
import AppSwitch from "../../../../../_shared/components/FormItems/AppSwitch"
import AppHeading from "../../../../../_shared/components/Typography/Heading"
import MarkupEditor from "../../../../../_shared/components/WYSIWYGEditor"
import useForm from "../../../../../_shared/hooks/useForm"

// ----------------------------------------------------------------------------

function _EventEditor(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, visible, eventData, onCancel, onConfirm } = props

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    const [values, setOne, setMany, clear] = useForm()
    // console.log("values", values)

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    useEffect(() => {
        if (eventData) {
            const {
                id,
                title,
                description,
                summary,
                bookingsOpen,
                published,
                price,
            } = eventData ?? {}
            setMany({
                id,
                description,
                summary,
                bookingsOpen,
                published,
                price,
                title,
            })
        } else {
            clear()
        }
        // eslint-disable-next-line
    }, [eventData])

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function onValueChange(field) {
        return (value) => {
            setOne(field, value)
        }
    }

    function handleConfirm() {
        onConfirm && onConfirm({ ...eventData, ...values })
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <StyledBottomSheet
            snapPoint={80}
            open={visible}
            title="Modifica anagrafica evento"
            onConfirm={handleConfirm}
            onCancel={onCancel}
            className={`${className}`}
        >
            <AppSwitch
                className="switch"
                value={values?.bookingsOpen}
                onChange={onValueChange("bookingsOpen")}
                label="Prenotazioni aperte"
            />
            <AppSwitch
                className="switch"
                value={values?.published}
                onChange={onValueChange("published")}
                label="Evento visibile"
            />

            <AppHeading className="heading" boldness="bold">
                Titolo
            </AppHeading>
            <MarkupEditor
                value={values?.title ?? ""}
                onChange={onValueChange("title")}
                placeholder="Titolo"
            />

            <AppHeading className="heading" boldness="bold">
                Descrizione breve
            </AppHeading>
            <MarkupEditor
                value={values?.summary ?? ""}
                onChange={onValueChange("summary")}
                placeholder="Summary"
            />
            <AppHeading className="heading" boldness="bold">
                Descrizione
            </AppHeading>
            <MarkupEditor
                value={values?.description || ""}
                onChange={onValueChange("description")}
                placeholder="Descrizione"
            />
            <AppHeading className="heading" boldness="bold">
                Prezzo
            </AppHeading>
            <AppInput
                className="duration"
                placeholder="10"
                type="number"
                value={values?.price}
                onChange={(e) => onValueChange("price")(e.target.value)}
            />
        </StyledBottomSheet>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_EventEditor.propTypes = {
    className: PropTypes.string.isRequired,
    visible: PropTypes.bool,
    eventData: PropTypes.object,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
}

_EventEditor.defaultProps = {}

// ----------------------------------------------------------------------------

const EventEditor = styled(_EventEditor)`
    & {
        .heading {
            margin-top: 30px;
        }
        .duration {
            width: 300px;
        }
        .switch {
            margin-top: 30px;
        }
    }
`
// ----------------------------------------------------------------------------

export default EventEditor
